module.exports = __webpack_public_path__ + "static/media/in-number-3.1f49407d.png";